"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var ChevronDoubleUp = function ChevronDoubleUp(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 96 96",
    ref: ref
  }, props), (0, _core.jsx)("path", {
    d: "M47.5141295,44.733006 C47.9828692,44.2637006 48.6189563,44 49.2822545,44 C49.9455526,44 50.5816397,44.2637006 51.0503795,44.733006 L69.8060045,63.498256 C70.451989,64.1270508 70.7096104,65.0548247 70.4803174,65.926664 C70.2510244,66.7985033 69.5702996,67.4794928 68.6985495,67.7091248 C67.8267994,67.9387567 66.8989255,67.681496 66.2698795,67.035756 L49.2823795,50.039756 L32.2948795,67.035756 C31.6660689,67.6826697 30.7376121,67.9408336 29.8651182,67.7113682 C28.9926242,67.4819027 28.3113074,66.8003691 28.0821194,65.9278023 C27.8529315,65.0552354 28.1113908,64.1268607 28.7585045,63.498256 L47.5141295,44.733006 Z M47.5141295,24.733006 C47.9828692,24.2637006 48.6189563,24 49.2822545,24 C49.9455526,24 50.5816397,24.2637006 51.0503795,24.733006 L69.8060045,43.498256 C70.451989,44.1270508 70.7096104,45.0548247 70.4803174,45.926664 C70.2510244,46.7985033 69.5702996,47.4794928 68.6985495,47.7091248 C67.8267994,47.9387567 66.8989255,47.681496 66.2698795,47.035756 L49.2823795,30.039756 L32.2948795,47.035756 C31.6660689,47.6826697 30.7376121,47.9408336 29.8651182,47.7113682 C28.9926242,47.4819027 28.3113074,46.8003691 28.0821194,45.9278023 C27.8529315,45.0552354 28.1113908,44.1268607 28.7585045,43.498256 L47.5141295,24.733006 Z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(ChevronDoubleUp);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ChevronDoubleUp, "ChevronDoubleUp", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ChevronDoubleUp.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ChevronDoubleUp.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();